// Fallback values target the local stack (local-dev/docker-compose.yml); REACT_APP_* env vars
// override them at build time for rc/sandbox/prod, per the variable-mapper map in
// .github/workflows/ui-build-push.yml.
export const AUTH_GATEWAY_URI = process.env.REACT_APP_AUTH_GATEWAY_URI || 'http://localhost:8080/no-local-login';
export const AUTH_LOGOUT_URI = process.env.REACT_APP_AUTH_LOGOUT_URI || 'http://localhost:8080/no-local-login';
export const AUTH_REFRESH_URI = `${
  process.env.REACT_APP_CONNECT_AUTH_BE_URI || process.env.REACT_APP_CONNECT_BE_URI || 'http://localhost:8080'
}/auth-srvc/auth/refresh`;

export const UNLEASH_ENV = process.env.REACT_APP_UNLEASH_ENV || 'development';
export const UNLEASH_CLIENT_KEY = process.env.REACT_APP_UNLEASH_CLIENT_KEY || 'local';
export const UNLEASH_PROXY_URI = process.env.REACT_APP_UNLEASH_PROXY_URI || 'http://localhost:8080/proxy';

export const GTM_ID = process.env.REACT_APP_GTM_ID || '';

export const CONNECT_BE_URI = process.env.REACT_APP_CONNECT_BE_URI || 'http://localhost:8080';
